module.exports = __webpack_public_path__ + "img/ios_qr.17e89433.png";